import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[fpAutofocus]'
})
export class FPAutofocus implements AfterViewInit {

  constructor(private elementRef: ElementRef) { };

  ngAfterViewInit() {
     
    this.elementRef.nativeElement.focus();
  }
}